'use strict';

const { h } = require('phy');

const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');
const OfferCalloutImage = require('../../shared/views/offer/offer-callout-image');
const OfferTypeLabel = require('../../shared/views/offer/offer-type-label');
const CouponButton = require('./coupon-button');
const OfferRedemptionCount = require('../../shared/views/offer/offer-redemption-count');
const OfferExpiry = require('../../shared/views/offer/offer-expiry');
const OfferViewTerms = require('../../shared/views/offer/offer-view-terms');
const OfferFinancialTerms = require('../../shared/views/offer/offer-financial-terms');
const OfferExclusive = require('../../shared/views/offer/offer-exclusive');

function getTileImage({ coupon, media, routes, lazy, color }) {
  if (media === 'callout') {
    return h(
      '.coupon-tile-callout',
      { style: { backgroundColor: color && `#${color}` } },
      [
        OfferCalloutImage({
          className: 'coupon-tile-callout-image',
          data: coupon && coupon.offerMedia,
          alt: '',
          size: ['w_160,h_80'],
          lazy,
        }),
      ]
    );
  }

  return h(
    'a.coupon-tile-logo',
    {
      href: routes.merchant.show.replace(
        '{merchantSlug}',
        coupon.merchant.merchantSlug
      ),
      'data-bhc': `store:${coupon.merchant.merchantSlug}`,
    },
    [
      MerchantLogoImage({
        data: coupon && coupon.merchant && coupon.merchant.merchantMedia,
        alt: `${coupon.merchant.merchantName} - ${coupon.calloutValue}`,
        size: ['w_90,h_90'],
      }),
    ]
  );
}

function CouponTile({
  coupon,
  media,
  routes,
  lazy = true,
  color,
  referralSource,
}) {
  const ExpiryElement = OfferExpiry({
    className: 'coupon-tile-expiry',
    expires: coupon.expiryDateTime,
  });

  const ExclusiveElement =
    coupon.isExclusive &&
    OfferExclusive({ className: 'coupon-tile-exclusive' });

  return h(
    `.coupon-tile${referralSource ? `.coupon-tile-${referralSource}` : ''}`,
    {
      'data-bhw': `coupon:${coupon.offerId}`,
    },
    [
      getTileImage({ coupon, media, routes, lazy, color }),
      h('.coupon-tile-inner', [
        h('.coupon-tile-content', [
          media !== 'callout' && [
            ExclusiveElement,
            h('p.coupon-tile-merchant', coupon.merchant.merchantName),
          ],
          h('p.coupon-tile-title', coupon.offerTitle),
          coupon.offerDescription &&
            h('p.coupon-tile-description', coupon.offerDescription),
          ExpiryElement,
        ]),
        OfferFinancialTerms({
          terms: coupon.financialTerms,
          className: 'coupon-tile-financial',
        }),
        h('.coupon-tile-info', [
          media !== 'logo' &&
            OfferTypeLabel({ coupon, className: 'coupon-tile-type' }),
          ExclusiveElement,
          OfferRedemptionCount({
            className: 'coupon-tile-used',
            stats: coupon.offerStatistics,
          }),
          ExpiryElement,
        ]),
        h('.coupon-tile-action', [
          OfferViewTerms({
            routes,
            offerId: coupon.offerId,
            className: 'coupon-tile-terms',
          }),
          CouponButton({
            coupon,
            routes,
            className: 'coupon-tile-button',
            referralSource,
          }),
        ]),
      ]),
    ]
  );
}

module.exports = CouponTile;
